export class MutableSettings {
    serialNumberSeed = null;
    serialNumberPrefix = null;
    quoteNumberSeed = null;
    quoteIgnoreItemIds = null;
    changeOrderClearableWorkCenters = null;
    shippingActivityWorkCenterId = null;
}
